export default "__VITE_ASSET__DVm_y08F__"